<template>
    <!-- 实物中奖用户信息录入 -->
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        class-name="vertical-center-modal"
        :styles="{top: '100px'}">
        <div class="diyModal">
            <div class="diyModalBg"
                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
                <img :src="diyModalBg[awardObj.bigWheelActivityType-1]">
            </div>
            <div class="awardContent">
                <div v-if="awardObj.bigWheelActivityType != '3'"
                    class="awardName ellipsis"
                    :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">{{ awardObj.goodsName || awardObj.rewardName}}</div>
                <div v-else
                    class="tiger-award-title">请填写收件人信息</div>
                <img :src="diyModalHead[awardObj.bigWheelActivityType-1]"
                    style="width: 100%; margin: 5px 0;">
                <div style="padding: 0 15px;">
                    <!-- 兑奖门店 -->
                    <van-cell-group class="group1">
                        <div v-if="!awardObj.extendConfigFlag && activityObj.channelFlag == '1' && storageChannelData && storageChannelData.length">
                            <van-field v-model="modelFormCustom.channelName"
                                v-if="!awardObj.extendConfigFlag"
                                size='large'
                                label-width="65px"
                                label="门店"
                                @focus="isTips=true"
                                @blur="isTips=false"
                                :placeholder="!isTips?'    请输入兑奖门店名称':''"
                                @input="remoteMethod"
                                clearable />
                            <van-icon v-show="searchHide && !isTips"
                                style="position: absolute; left: 90px; top: 17px;z-index: 100;width: 15px;height: 15px; color: #CFD0D2;"
                                name="search" />
                            <div class="channelOption"
                                v-show="isTips&&modelFormCustom.channelName">
                                <div @click="modelFormCustom.channelName=option.channelName"
                                    v-for="(option, index) in channelNameFilterList"
                                    :value="option.channelName"
                                    :key="index">
                                    {{option.channelName}}
                                </div>
                                <div class="notOption"
                                    v-show="!channelNameFilterList.length">无匹配数据</div>
                            </div>
                        </div>
                        <van-field v-model="awardObj.channelName"
                            readonly
                            v-if="awardObj.extendConfigFlag && awardObj.channelName"
                            size='large'
                            label-width="65px"
                            label="门店" />
                    </van-cell-group>
                    <!-- 顾客姓名 -->
                    <van-cell-group class="group1">
                        <van-field v-model="modelFormCustom.userName"
                            size='large'
                            label-width="65px"
                            label="姓名"
                            @focus="isUserName=true"
                            @blur="isUserName=false"
                            :placeholder="!isUserName?'请输入姓名':''"
                            :readonly="isFormReadonly"
                            clearable />
                    </van-cell-group>
                    <!-- 顾客电话 -->
                    <van-cell-group>
                        <van-field v-model="modelFormCustom.userPhone"
                            size='large'
                            label-width="65px"
                            label="电话"
                            @focus="isUserPhone=true"
                            @blur="isUserPhone=false"
                            :placeholder="!isUserPhone?'请输入电话':''"
                            :readonly="isFormReadonly"
                            clearable />
                    </van-cell-group>
                    <!-- 顾客地址 -->
                    <van-cell-group>
                        <van-field label="地址"
                            placeholder="请选择省份/城市/地区"
                            v-model="userAddress"
                            label-width="65px"
                            @click.stop="selectAddress"
                            size='large'
                            readonly
                            clearable />
                    </van-cell-group>
                    <!-- 详细地址 -->
                    <van-cell-group>
                        <van-field label="详细地址"
                            @focus="isUserAddress=true"
                            @blur="isUserAddress=false"
                            :placeholder="!isUserAddress?'请输入详细地址':''"
                            v-model="modelFormCustom.userAddress"
                            label-width="65px"
                            maxlength="50"
                            size='large'
                            :readonly="isFormReadonly"
                            clearable />
                    </van-cell-group>
                    <div v-if="awardObj.singleFlag && awardObj.jumpType === '1'"
                        style="text-align: center; color: #999999; margin: 15px 0 0 0;">点击确认返回Hi荣耀首页</div>
                </div>
            </div>
            <div class="diyReceive">
                <div class="diyModalButton"
                    :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''"
                        src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div class="diyModalButtonText">
                        <div v-if="!awardObj.extendConfigFlag && !awardObj.singleFlag"
                            :class="{'tiger-btn' : awardObj.bigWheelActivityType == '3'}"
                            @click="modalOk">提交</div>
                        <div v-if="awardObj.extendConfigFlag && !awardObj.singleFlag"
                            :class="{'tiger-btn' : awardObj.bigWheelActivityType == '3'}"
                            @click="modalCancel(true)">关闭</div>
                        <div v-if="awardObj.singleFlag"
                            :class="{'tiger-btn' : awardObj.bigWheelActivityType == '3'}"
                            @click="nextStep(isFormReadonly,awardObj.jumpUrl,awardObj.jumpType)">
                            {{ modalButtonText }}</div>
                    </div>
                </div>
            </div>
            <div class="diyClose"
                @click="modalCancel"><van-icon name="close" /></div>
        </div>
        <!-- 地址选择组件 -->
        <AreaSelect ref="areaSelect" @selectArea="handleGetAdd"></AreaSelect>
    </van-dialog>
</template>

<script>
import { ActionSheet, Area, Cell, CellGroup, Icon, Dialog, Field, Toast } from 'vant';
import { BigWheelConstants as BWC } from '../../lucky-draw/common/global-variable.js';
import AreaSelect from '../../../../../components/modal/area-select.vue'
import 'jquery';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [ActionSheet.name]: ActionSheet,
    [Area.name]: Area,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    AreaSelect,
  },
  props: {
    awardObj: Object,
    activityObj: Object,
    referrFlag: String,
    modalButtonText: String,
  },
  data() {
    return {
      searchHide: true,
      isVisibility: false,
      modelFormCustom: {
        userName: '',
        userPhone: '',
        userAddress: '',
        channelName: '',
        userCountryName: '中国',
        userProvinceName: '',
        userCityName: '',
        userZoneName: '',
      },
      showIconFlag: false,
      showChannelFlag: false,
      channelNameDataList: [],
      storageChannelData: [],
      channelNameLoading: false,
      self: {},
      channelNameFilterList: [],
      isTips: false,
      isUserName: false,
      isUserPhone: false,
      isUserAddress: false,
      userAddress: '',

      isClick: false,
      diyModalBg: [
        'static/runtime/images/magic/award/diyModalBg.png',
        'static/runtime/images/magic/award/awardBg2.png',
        'static/runtime/images/magic/award/tiger-bj.png',
        'static/runtime/images/magic/award/diyModalBg.png',
      ],
      diyModalHead: [
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
        'static/runtime/images/magic/award/awardBg1.png',
        'static/runtime/images/magic/award/tiger-machine-head-bg.png',
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
      ],
      BWC: BWC,
    };
  },
  created() {
    let params = (this.$route.query && this.$route.query.activityCode) || '';
    this.channelNameListData(params);
    document.addEventListener('click', function () {
      this.showChannelFlag = false;
    });
  },
  mounted() {},
  computed: {
    rewardDescri() {
      if (this.awardObj.rewardDescri) {
        return this.awardObj.rewardDescri.replace(/↵/g, '<br/>').replace(/\n/g, '<br/>');
      } else {
        return '';
      }
    },
    getButtonBgStyle() {
      return {
        background: this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
      };
    },
    // 表单是否只读
    isFormReadonly() {
      // 以下3种情况，实物-线上邮寄的用户信息录入弹窗表单可修改，否则只读
      if ([BWC.ActivityStatus.running, BWC.ActivityStatus.paused].includes(this.awardObj.activityStatus)) {
        if (this.awardObj.extendConfigFlag === true && this.awardObj.goodsOverdueFlag === false && this.awardObj.hasLockedFlag === false) {
          // 1、（活动进行中 或 活动已暂停） 且 用户已填写 且 权益品未过期 且 奖项未锁定
          return false;
        }
        if (this.awardObj.extendConfigFlag === false) {
          // 2、（活动进行中 或 活动已暂停） 且 用户未填写
          return false;
        }
        return true;
      } else if (this.awardObj.activityStatus === BWC.ActivityStatus.finished && this.awardObj.extendConfigFlag === false) {
        // 3、活动已结束 且 用户未填写
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    'awardObj.extendConfigFlag': function (val) {
      if (!val) {
        this.modelFormCustom.userName = '';
        this.modelFormCustom.userPhone = '';
        this.modelFormCustom.userAddress = '';
        this.modelFormCustom.userProvinceName = '';
        this.modelFormCustom.userCityName = '';
        this.modelFormCustom.userZoneName = '';
        this.modelFormCustom.channelName = '';
        this.userAddress = '';
      }
    },
    'modelFormCustom.channelName': function (val) {
      if (val) {
        this.searchHide = false;
      } else {
        this.searchHide = true;
      }
    },
    isVisibility(val) {
      if (!val) {
        this.modelFormCustom = {
          userName: '',
          userPhone: '',
          userAddress: '',
          channelName: '',
          userCountryName: '中国',
          userProvinceName: '',
          userCityName: '',
          userZoneName: '',
        };
        this.userAddress = '';
      } else {
        // 从其他页面跳转过来，重置表单提示信息
        this.isUserName = false;
        this.isUserPhone = false;
        this.isUserAddress = false;

        this.modelFormCustom.userName = this.awardObj.userName;
        this.modelFormCustom.userPhone = this.awardObj.userPhone;
        this.modelFormCustom.userAddress = this.awardObj.userAddress;
        this.modelFormCustom.userProvinceName = this.awardObj.userProvinceName;
        this.modelFormCustom.userCityName = this.awardObj.userCityName;
        this.modelFormCustom.userZoneName = this.awardObj.userZoneName;
        this.modelFormCustom.channelName = this.awardObj.channelName;
        if (this.awardObj.userProvinceName && this.awardObj.userCityName && this.awardObj.userZoneName) {
          this.userAddress = `${this.awardObj.userProvinceName} / ${this.awardObj.userCityName} / ${this.awardObj.userZoneName}`;
        }
      }
    },
  },
  methods: {
    /*
     * 兑奖门店动态下拉数据处理
     * @param {String} query：输入的数据
     */
    remoteMethod(query) {
      if (query) {
        this.channelNameFilterList =
          this.channelNameDataList &&
          this.channelNameDataList.filter((item) => {
            return item.channelName.indexOf(query) > -1;
          });
      } else {
        this.channelNameFilterList = [];
      }
    },

    /*
     * 门店下拉框展开或收起时触发
     * @param {Boolean} bool:   展开:true,收起:false
     */
    handleOpenChange(bool) {
      this.isTips = bool;
    },
    openModel() {
      this.isVisibility = true;
      this.$nextTick(() => {
        this.searchHide = true;
      });
    },
    // 加载门店名称数据:
    channelNameListData(result) {
      let self = this;
      let params = {};
      self.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/selectChannelDetailByBigWheel/' + result,
        params: params,
        success: (r) => {
          let list = r.result || [];
          self.channelNameDataList = list;
          self.storageChannelData = list;
        },
      });
    },
    searchChannelName() {
      this.showChannelFlag = true;
      this.showIconFlag = !this.showIconFlag;
      // this.channelNameListData();
    },
    hideDiv(event) {
      event = event || window.event;
      event.stopPropagation();
    },
    channelNameRemoteMethod(query) {
      if (query) {
        this.searchHide = false;
        self.channelNameLoading = true;
      } else {
        this.modelFormCustom.channelName = '';
        this.searchHide = true;
        self.channelNameLoading = false;
      }
    },
    // 门店下拉选择change
    channelNameChange(codeIdList) {
      if (codeIdList) this.searchHide = false;
      else this.searchHide = true;
    },
    // 选择门店
    chooseChannel(item) {
      this.modelFormCustom.channelName = item.channelName;
      this.showIconFlag = true;
      this.showChannelFlag = !this.showChannelFlag;
    },
    modalOk() {
      let self = this;
      let obj = Object.assign({}, self.modelFormCustom);
      if (self.activityObj.channelFlag == '2') {
        if (!obj.userName) {
          Toast('请输入姓名');
          return false;
        } else if (!obj.userPhone) {
          Toast('请输入电话');
          return false;
        } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
          Toast('请输入正确的电话号码');
          return false;
        } else if (!this.userAddress) {
          Toast('请选择所在省市区');
          return false;
        } else if (!obj.userAddress) {
          Toast('请输入详细地址');
          return false;
        } else if (obj.userAddress.length < 5) {
          Toast('详细地址不能少于五个字符');
          return false;
        }
      } else {
        if (self.storageChannelData && self.storageChannelData.length > 0) {
          if (!obj.userName && !obj.channelName && !obj.userPhone && !obj.userAddress && !this.userAddress) {
            Toast('请输入兑奖门店或收货信息');
            return false;
          }
          if (obj.channelName) {
            let currentChannel = [];
            currentChannel = self.storageChannelData.filter((item) => {
              return item.channelName == obj.channelName;
            });
            if (currentChannel.length < 1) {
              Toast('兑奖门店名称不存在，请重新新输入查询');
              self.modelFormCustom.channelName = '';
              return false;
            } else {
              self.modelFormCustom.channelName = currentChannel && currentChannel[0] && currentChannel[0].channelName;
              obj.channelName = currentChannel && currentChannel[0] && currentChannel[0].channelName;
              obj.channelCode = currentChannel && currentChannel[0] && currentChannel[0].channelCode;
            }
            if (obj.userPhone) {
              if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
                Toast('请输入正确的电话号码');
                return false;
              }
            }
          } else {
            if (!obj.userName) {
              Toast('请输入姓名');
              return false;
            } else if (!obj.userPhone) {
              Toast('请输入电话');
              return false;
            } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
              Toast('请输入正确的电话号码');
              return false;
            } else if (!this.userAddress) {
              Toast('请选择所在省市区');
              return false;
            } else if (!obj.userAddress) {
              Toast('请输入详细地址');
              return false;
            } else if (obj.userAddress.length < 5) {
              Toast('详细地址不能少于五个字符');
              return false;
            }
          }
        } else {
          if (!obj.userName) {
            Toast('请输入姓名');
            return false;
          } else if (!obj.userPhone) {
            Toast('请输入电话');
            return false;
          } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
            Toast('请输入正确的电话号码');
            return false;
          } else if (!this.userAddress) {
            Toast('请选择所在省市区');
            return false;
          } else if (!obj.userAddress) {
            Toast('请输入详细地址');
            return false;
          } else if (obj.userAddress.length < 5) {
            Toast('详细地址不能少于五个字符');
            return false;
          }
        }
      }
      if (this.isClick) return;
      this.isClick = true;
      let privacyKeys = {
        userName: '$PrivacyPlain$',
        userPhone: '$PrivacyPlain$',
        userAddress: '$PrivacyPlain$',
      };
      //隐私信息保存
      let privacyKeyLsit = [
        {
          userName: 'userName',
          typeText: 'NAME',
          labelText: 'mktMagicShareCpsUserName',
        },
        {
          userPhone: 'userPhone',
          typeText: 'MOBILE_PHONE_NO',
          labelText: 'mktStudentRewardRecodeUserPhone',
        },
        {
          userAddress: 'userAddress',
          typeText: 'ADDRESS',
          labelText: 'mktMagicShareCpsUserAddress',
        },
      ];
      self.$utils.privacySave(privacyKeys, privacyKeyLsit, obj);
      let params = {
        bigwheelRewardRecodeId: self.awardObj.recordId || self.awardObj.bigwheelRewardRecodeId,
        userName: obj.userName,
        userPhone: obj.userPhone,
        userAddress: obj.userAddress,
        userCountryName: obj.userCountryName,
        userProvinceName: obj.userProvinceName,
        userCityName: obj.userCityName,
        userZoneName: obj.userZoneName,
        channelName: obj.channelName,
        extendConfigChannelCode: obj.channelCode,
        referrFlag: this.referrFlag ? this.referrFlag : 0,
      };
      self.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/update',
        params: params,
        success: (r) => {
          if (r && r.code === 200) {
            self.isVisibility = false;
            Toast('奖品领取成功，可在"我的中奖记录"里查看');
            self.$emit('refreshRecord');
            setTimeout(() => {
              this.isClick = false;
            }, 10);
          } else {
            Toast(r.message || '提交失败');
          }
        },
        failure: () => {
          setTimeout(() => {
            this.isClick = false;
          }, 10);
        },
      });
    },
    modalCancel(flag) {
      this.isVisibility = false;
      if (flag) return;
    },
    nextStep(flag, link, type) {
      if (flag) {
        if (type === '9') {
          this.isVisibility = false;
        }
        this.$emit('nextStep', link, type);
      } else {
        let self = this;
        let obj = Object.assign({}, self.modelFormCustom);
        if (self.activityObj.channelFlag == '2') {
          if (!obj.userName) {
            Toast('请输入姓名');
            return false;
          } else if (!obj.userPhone) {
            Toast('请输入电话');
            return false;
          } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
            Toast('请输入正确的电话号码');
            return false;
          } else if (!this.userAddress) {
            Toast('请选择所在省市区');
            return false;
          } else if (!obj.userAddress) {
            Toast('请输入详细地址');
            return false;
          } else if (obj.userAddress.length < 5) {
            Toast('详细地址不能少于五个字符');
            return false;
          }
        } else {
          if (self.storageChannelData && self.storageChannelData.length > 0) {
            if (!obj.userName && !obj.channelName && !obj.userPhone && !obj.userAddress && !this.userAddress) {
              Toast('请输入兑奖门店或收货信息');
              return false;
            }
            if (obj.channelName) {
              let currentChannel = [];
              currentChannel = self.storageChannelData.filter((item) => {
                return item.channelName == obj.channelName;
              });
              if (currentChannel.length < 1) {
                Toast('兑奖门店名称不存在，请重新新输入查询');
                return false;
              } else {
                self.modelFormCustom.channelName = currentChannel && currentChannel[0] && currentChannel[0].channelName;
                obj.channelName = currentChannel && currentChannel[0] && currentChannel[0].channelName;
                obj.channelCode = currentChannel && currentChannel[0] && currentChannel[0].channelCode;
              }
              if (obj.userPhone) {
                if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
                  Toast('请输入正确的电话号码');
                  return false;
                }
              }
            } else {
              if (!obj.userName) {
                Toast('请输入姓名');
                return false;
              } else if (!obj.userPhone) {
                Toast('请输入电话');
                return false;
              } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
                Toast('请输入正确的电话号码');
                return false;
              } else if (!this.userAddress) {
                Toast('请选择所在省市区');
                return false;
              } else if (!obj.userAddress) {
                Toast('请输入详细地址');
                return false;
              } else if (obj.userAddress.length < 5) {
                Toast('详细地址不能少于五个字符');
                return false;
              }
            }
          } else {
            if (!obj.userName) {
              Toast('请输入姓名');
              return false;
            } else if (!obj.userPhone) {
              Toast('请输入电话');
              return false;
            } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
              Toast('请输入正确的电话号码');
              return false;
            } else if (!this.userAddress) {
              Toast('请选择所在省市区');
              return false;
            } else if (!obj.userAddress) {
              Toast('请输入详细地址');
              return false;
            } else if (obj.userAddress.length < 5) {
              Toast('详细地址不能少于五个字符');
              return false;
            }
          }
        }
        if (this.isClick) return;
        this.isClick = true;
        let privacyKeys = {
          userName: '$PrivacyPlain$',
          userPhone: '$PrivacyPlain$',
          userAddress: '$PrivacyPlain$',
        };
        //隐私信息保存
        let privacyKeyLsit = [
          {
            userName: 'userName',
            typeText: 'NAME',
            labelText: 'mktMagicShareCpsUserName',
          },
          {
            userPhone: 'userPhone',
            typeText: 'MOBILE_PHONE_NO',
            labelText: 'mktStudentRewardRecodeUserPhone',
          },
          {
            userAddress: 'userAddress',
            typeText: 'ADDRESS',
            labelText: 'mktMagicShareCpsUserName',
          },
        ];
        self.$utils.privacySave(privacyKeys, privacyKeyLsit, obj);
        let params = {
          bigwheelRewardRecodeId: self.awardObj.recordId || self.awardObj.bigwheelRewardRecodeId,
          userName: obj.userName,
          userPhone: obj.userPhone,
          userAddress: obj.userAddress,
          userCountryName: obj.userCountryName,
          userProvinceName: obj.userProvinceName,
          userCityName: obj.userCityName,
          userZoneName: obj.userZoneName,
          channelName: obj.channelName,
          extendConfigChannelCode: obj.channelCode,
          referrFlag: this.referrFlag ? this.referrFlag : 0,
        };
        const isNext = this.awardObj.effectiveEndTime ? new Date() > new Date(this.awardObj.effectiveEndTime) : false;
        if (isNext) {
          Toast('超过领取时间，无法兑换');
          setTimeout(() => {
            this.isClick = false;
          }, 10);
          return;
        }
        self.$api.post({
          sc: 'mobileMarketing',
          url: 'h5/bigWheel/reward/record/update',
          params: params,
          success: (r) => {
            if (r && r.code === 200) {
              Toast('奖品领取成功，可在"我的中奖记录"里查看');
              self.isVisibility = false;
              this.$emit('nextStep', link, type);
              self.$emit('refreshRecord');
              setTimeout(() => {
                this.isClick = false;
              }, 10);
            } else {
              Toast(r.message || '提交失败');
              this.isClick = false;
            }
          },
          failure: () => {
            setTimeout(() => {
              this.isClick = false;
            }, 10);
          },
        });
      }
    },
    selectAddress() {
      if (!this.isFormReadonly) {
        // 表单可修改场景下，打开地址选择上拉组件
        this.$refs.areaSelect.showDialog()
        console.log('aaaaaaaaa')
      }
    },
    /*
     * 保存选择的地址
     * @param {Array} data: 选择好的地址数据
     * @author <fangyan f84162999>
     */
    handleGetAdd(area) {
      let data = []
      area.forEach(item=>{
        let tempObj = {
          code : item.id,
          name : item.name
        }
        data.push(tempObj)
      })
      this.userAddress = `${data[0].name} / ${data[1].name} / ${data[2].name}`;
      this.modelFormCustom.userProvinceName = data[0].name;
      this.modelFormCustom.userCityName = data[1].name;
      this.modelFormCustom.userZoneName = data[2].name;
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  // height: 120vh;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .diyModal {
      width: 320px;
      // max-width: 694px;
      height: auto;
      margin: auto;
      min-height: 245px;
      padding-bottom: 125px;
      position: relative;
      z-index: 10;
      .tiger-modal-bg {
        img {
          // height: 210px;
        }
      }
      .other-modal-bg {
        img {
          height: 210px;
        }
      }
      .diyModalBg {
        width: 100%;
        height: 210px;
        border-radius: 20px;
        position: absolute;
        bottom: 0;
        z-index: -1;
        overflow: hidden;
        &::before {
          content: '';
          width: 98%;
          height: 150px;
          position: absolute;
          bottom: 1px;
          background: #ffffff;
          border-radius: 26px;
        }
        img {
          width: 100%;
          position: absolute;
          bottom: -1px;
        }
      }
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background: #ffffff;
        text-align: center;
        border-radius: 20px 20px 0 0;
        .tiger-award-title {
          font-family: HYQiHei-FZS;
          font-size: 18px;
          color: #29231e;
          text-align: center;
          font-weight: 400;
          padding-top: 20px;
        }

        .awardName {
          color: #2592f7;
          font-size: 14px;
          padding: 26px 10px 0;
          text-align: center;
        }
        .channelOption {
          width: 175px;
          position: absolute;
          top: 45px;
          left: 87px;
          max-height: 200px;
          overflow: auto;
          margin: 5px 0;
          padding: 5px 0;
          background-color: #fff;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          border-radius: 4px;
          -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
          position: absolute;
          z-index: 900;
          div {
            width: initial;
            margin: 0;
            line-height: normal;
            padding: 7px 16px 0;
            margin-bottom: 7px;
            clear: both;
            color: #495060;
            font-size: 12px;
            word-break: break-all;
            list-style: none;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          .notOption {
            text-align: center;
            color: #bbbec4;
            font-size: 14px;
            padding: 0;
            margin: 0;
          }
        }

        .group1 {
          &::after {
            border: none;
          }
        }

        .van-cell-group {
          .van-cell--large .van-cell__title {
            font-size: 14px;
          }
        }
      }
      .tiger-btn {
        font-family: HYQiHei-EES;
        color: #d7324c;
        font-size: 18px;
      }
      .diyReceive {
        width: 100%;
        height: 140px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .tiger-btn-img {
          width: 90% !important;
          height: 80% !important;
        }
        .diyModalButton,
        .blindBoxBtn {
          width: 200px;
          height: 45px;
          margin-top: 54px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          position: relative;
          img,
          .diyModalButtonBg {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .diyModalButtonBg {
            background: #ffffff;
            border-radius: 36px;
          }
          .diyModalButtonText {
            width: 100%;
            height: 100%;
            position: absolute;
            div {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .blindBoxBtn {
          color: #b27d13 !important;
          font-size: 16px;
          height: 36px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}

.copy {
  color: #2592f7;
  border: 1px solid #2592f7;
  text-align: center;
  line-height: 28px;
  padding: 2px 10px 1px;
  border-radius: 15px;
  font-size: 12px;
  margin-left: 5px;
}
.defaultGray {
  color: #666666;
}

.noBorder input,
.noBorder textarea {
  border: none;
  outline: none;
}
.noBorder input:focus,
.noBorder input:hover,
.noBorder textarea:focus,
.noBorder textarea:hover {
  box-shadow: none;
  border: none;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/kindAwardModal.vue